import { Component, NgZone } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { ReviewsLeaderboardPage } from '../reviews-leaderboard/reviews-leaderboard.page';
import { Router } from '@angular/router';
import { AskPhonePage } from '../ask-phone/ask-phone.page';
import { MenuPage } from '../menu/menu.page';
import { SurveyAlertPage } from '../survey-alert/survey-alert.page';
// import {ReviewsLeaderboardPage }
declare var google;
declare var FB: any;
@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {
  resList: any = [];
  places: any;
  searchRest: any;
  search: boolean = false;
  searchItems: any;
  status: boolean = true;
  toggle = '00';
  new: any;
  addressSearch: boolean = false;
  geo: any;
  temp: boolean = false;
  email:any;
  autocompleteItems: any;
  autocomplete: any;
  service = new google.maps.places.AutocompleteService();
  items: Object[] = [];
  pageOfItems: Array<any>;
  limit = 20;
  radius = 10;
  offset = 0;
  noData: string;
  hasData: boolean = true;
  UserID: any;
  isLoggedIn: any;
  userName: string = '';
  showProfileCard = false;
  showNotif = false;
  currentTimeSpan = Math.round(Date.now() / 1000);

  cuisinesList = [];
  dataNotLoaded = true;
  activeColor: string = '#000000';
  bannersList = [];
  loading: any;
  showLoading: boolean = false;
  timeIs: string;
  recTime: any;
  newArray = [];
  loadMore: boolean = false;
  WEBPlatform: boolean;
  userPhone: string=''
  constructor(
    public nav: NavController,
    public globals: GlobalVariable,
    public server: ServerService,
    public alertCtrl: AlertController,
    public geolocation: Geolocation,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public socialShare: SocialSharing,
    public zone: NgZone,
    public modalCtrl: ModalController,
    public router: Router
  ) {
    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };

    this.globals.checkGPSPermission();
  }

  ionViewWillLeave() {
    // this.offset=0;
    // this.limit=10;
    // this.resList=[];
    this.globals.dataNotLoaded = true;
    // this.limit=2;
    console.log('leaving landing page');
    // this.pageLoading();
    // if (this.showLoading) {
    //   this.loading.dismiss()
    // }
  }
  ionViewWillEnter() {
    //  console.log( this.router.getCurrentNavigation().initialUrl)
    let email = localStorage.getItem('userEmail');
    if(email!='null' && email!=null){
      this.email=email
    }
    this.globals.activeCreditCard;
    let currentUrl = window.location.hostname;
    if (this.globals.webURL == currentUrl) {
      this.WEBPlatform = true;
      console.log();
    } else {
      this.WEBPlatform = false;
    }
    if (this.globals.activeCreditCard != undefined) {
      console.log('active credit card', this.globals.activeCreditCard);
    }
    if (this.globals.address == '') {
      console.log('here in get location');
      this.getLocation();
    } else {
      console.log('here in loading list');

      this.list();
    }
    setInterval(() => {
      console.log('background check');
      if (this.globals.appInBackground == false) {
        console.log('waking up and loading list again');
        this.list();
        // this.getLocation(); //testing
        this.globals.appInBackground = true;
      }
    }, 10000);

    this.getLoginInfo();
    this.loadBanner();
    
    // let temArray = this.globals.allNotifications;
    // if (temArray.length > 0) {
    //   temArray.forEach(ele => {
    //     // console.log('notification', ele)
    //   })
    // }
    this.getAllNotifications();
    // this.getCuisinesList();  commented on 1/26
    this.getBanners();
    if(!this.globals.hideSurveyPoll && this.globals.udid){
      this.getSurveys();
    }
    // this.getNotificationTime();
    // setInterval(()=> {
    //   this.newArray=[];
    //   this.getNotificationTime() }, 1000*60);
  }
  lengthGet(x) {
    if (x.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  getSurveys(){
    this.server.getSurveyList().subscribe(res=>{
      console.log(res);
      if(res.success){
        this.globals.EventList=res.data;
        this.surveyAlert();
      }
    })
  }
  getNotificationTime() {
    let temArray = this.globals.allNotifications;
    if (temArray.length > 0) {
      temArray.forEach((ele) => {
        this.recTime = ele.time;
        // console.log('recieved time', this.recTime)
        //  this.newArray
        //  let currentTimeSpan=Math.round(Date.now())
        let currentTimeSpan = Date.now();
        // console.log('current time is', currentTimeSpan)
        this.newArray.push({
          data: ele.message,
          time: this.timeDifference(currentTimeSpan, this.recTime),
        });
      });
    }
    console.log(this.newArray);
  }
  timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = current - previous;

    if (elapsed < msPerMinute) {
      console.log(Math.round(elapsed / 1000) + ' seconds ago');
      // this.timeIs = Math.round(elapsed / 1000) + ' seconds ago'
      return Math.round(elapsed / 1000) + ' seconds ago';
    } else if (elapsed < msPerHour) {
      console.log(Math.round(elapsed / msPerMinute) + ' minutes ago');
      // this.timeIs = Math.round(elapsed / msPerMinute) + ' minutes ago'
      return Math.round(elapsed / msPerMinute) + ' minutes ago';
    } else if (elapsed < msPerDay) {
      console.log(Math.round(elapsed / msPerHour) + ' hours ago');
      // this.timeIs = Math.round(elapsed / msPerHour) + ' hours ago';
      return Math.round(elapsed / msPerHour) + ' hours ago';
    } else if (elapsed < msPerMonth) {
      // this.timeIs = Math.round(elapsed / msPerDay) + ' days ago';
      return Math.round(elapsed / msPerDay) + ' days ago';
    } else if (elapsed < msPerYear) {
      // this.timeIs = Math.round(elapsed / msPerMonth) + ' months ago';
      return Math.round(elapsed / msPerMonth) + ' months ago';
    } else {
      this.timeIs = Math.round(elapsed / msPerYear) + ' years ago';
      return 'approximately ' + Math.round(elapsed / msPerYear) + ' years ago';
    }
  }
  doInfinite(infiniteScroll: any) {

    setTimeout(() => {
      if (this.loadMore == true) {
        this.list();
        this.loadMore = false;
      } else {
        console.log('wait for data to load/no more data');
      }
      infiniteScroll.target.complete();
    }, 800);
  }
  // navigate(data){
  //   this.nav.navigateForward('url', { state: data });

  // }
  getBanners() {
    let response = this.server.getOfferBanners();
    response.subscribe((data) => {
      console.log('banners', data);
      if (data.status == true) {
        this.bannersList = data.data;
      }
    });
  }
  getAllNotifications() {
    let response = this.server.getAllNotifications();
    response.subscribe((res) => {
      console.log('notifications from api', res);

      if (res.status) {
        this.globals.allNotifications = res.response;
      }
    });
  }
  getLocation() {
    this.globals.presentToast('Getting location...');
    this.geolocation.getCurrentPosition().then(
      (position) => {
        this.addressSearch = false;
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.reverseGeoCoding();
      },
      async (err) => {
        let alert = await this.alertCtrl.create({
          header: this.globals.locationAlert_title,
          subHeader: this.globals.locationAlert_text,
          buttons: [
            {
              text: 'Cancel',
              handler: (data) => {
                this.list();
                // console.log('Cancel clicked');
              },
            },
            {
              text: 'OK',
              handler: (data) => {
                this.list();
                // console.log('Ok clicked');
              },
            },
          ],
        });

        alert.present();
        // console.log(err);
      }
    );
  }
  reverseGeoCoding() {
    let response = this.server.getAddress(this.globals.mycoordinates);
    var myadress = '';
    response.subscribe(
      (data) => {
        console.log('data from adrress api ', data);
        myadress = data.address;
        this.globals.address = myadress;
        this.globals.dataNotLoaded = true;
        this.resList = [];
        this.hasData = true;
        this.offset = 0;
        this.limit = 20;
        this.list();
        // this.list();
      },
      (error) => {
        this.globals.presentToast('Please Turn on your location.');
      }
    );
  }
  loadBanner() {
    let response = this.server.LoadBannersOnHomePage();
    response.subscribe(
      (data) => {
        console.log('banners', data);
        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;

        //newadded
        this.globals.BusinessDiscount = data.discount;
        this.globals.availed_discount_count = parseInt(
          data.customer_discount_availed_count
        );
        this.globals.business_discount_count = parseInt(
          data.business_discount_count
        );
        //new added
        // ll
        if (data.theme_color) {
          this.globals.appColor = data.theme_color;
        } else {
          this.globals.appColor = '#000000';
        }

        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;
      },
      (error) => {
        console.log('no network', error);
        this.globals.presentToast(
          'Seems like your Network is not providing service. Try recharging'
        );
        // let alert = this.alertCtrl.create({
        //     message: 'Seems like your Network is not providing service. Try recharging',
        //     buttons: ['OK']
        // })
        // alert.present();
      }
    );
  }
  list() {
    // this.globals.dataNotLoaded=true;

    let response = this.server.getRestaurantslist(
      this.globals.radius,
      'main',
      this.globals.mycoordinates,
      this.offset,
      'order',
      this.limit
    );
    response.subscribe(
      (data) => {
        this.globals.dataNotLoaded = false;
        console.log(data);
        if (data.status == 'true') {
          // if(this.loadMore==true){
          this.items = data.results;
          console.log('list length is ', this.items.length);
          console.log('reslist', this.items);
          // this.offset = this.limit; //first time its 0=2
          // this.limit = this.limit + 2; //2=2
          // this.resList=this.items
          for (let i = 0; i < this.limit; i++) {
            this.resList.push(this.items[i]);
            console.log('length of reslist ', this.resList.length);
          }
          this.loadMore = true;
          this.globals.dataNotLoaded = false;

          // this.offset = this.limit; //first time its 0=2
          this.offset = this.offset + 20; //2=2
          console.log('limit is ', this.limit);
          console.log('offset is ', this.offset);
        }
        // }
        if (data.status == 'false') {
          console.log('no data');
          this.hasData = false;
        }
      },
      (error) => {
        this.globals.dataNotLoaded = false;

        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  async getLoginInfo() {
    // this.nativeStorage.getItem('user').then(data => {
    //   this.UserID=Number(data.id)
    //   console.log(this.UserID)
    // })
    this.isLoggedIn = localStorage.getItem('isLogin');
    let phone = localStorage.getItem('userphone');
    this.userPhone = phone;
    // alert(phone)
    // if(phone=='' || phone==null || phone==='+1undefined'){
    //   this.userPhone=null
    // }
    console.log('userphone fromstr', this.userPhone);
    // alert(this.userPhone);
    this.userName = localStorage.getItem('firstname');
    let udid = localStorage.getItem('udid');
    this.globals.udid = udid;
    let neverAskForPhone = localStorage.getItem('askforphone');
    console.log('ask for phone', neverAskForPhone);
    // if(askForPhone==null){
    //   askForPhone='true';
    // }
    

    // !this.globals.comingFromLogin
    if (
      this.isLoggedIn == 'true' && //logged in hai
      neverAskForPhone != 'true' && //localstorage sy askfor phone ..phone not found from storage
      this.globals.laterAskPhone == false && //asklater.. later button clickedornot.. show only if false;
      this.userPhone == null //phone not found
      //  || this.userPhone==undefined // check as undefined
      //  || this.userPhone==''//checking for empty etring
    ) {
      console.log('invalid phone asking for phone');
      this.askForPhone();
    }

    this.userName = localStorage.getItem('firstname');
    console.log('name is ',this.userName);

    if(this.isLoggedIn == 'true'){
      if( this.userName==undefined || this.userName==null || this.userName=='' || this.userPhone == null || 
      this.userPhone == '' || this.userPhone == undefined || this.userPhone.length<9 || !this.email ||this.email.length<7
      ){
        const alert =await this.alertCtrl.create({
          subHeader:'Incomplete Profile',
          message:"Your profile is incomplete! Please go to settings page and add missing information, otherwise"
          +" you'll not be able to use The Halal Guide app.",
          backdropDismiss:false,
          mode:'ios',
          buttons: [
            // {
            //   text: 'Cancel',
            //   role: 'cancel',
            //   cssClass: 'secondary',
            //   handler: () => {
            //     console.log('Confirm Cancel: blah');
            //   }
            // },
             {
              text: 'Go to Settings',
              handler: () => {
                console.log('Confirm Okay');
                this.router.navigate(['settings']);
              }
            }
          ]
        
          
        })
        alert.present()
      }
    }
    
  }

  getCuisinesList() {
    let response = this.server.getCuisines();
    response.subscribe((data) => {
      this.dataNotLoaded = false;
      // console.log("cuicines data", data);
      // if(data.reponse==true){
      this.cuisinesList = data.data;
      if (this.cuisinesList.length > 0) {
        this.globals.cuisineID = this.cuisinesList[0].id;
      }

      // console.log("cuicines data", this.cuisinesList);
      // }
    });
  }
  async pageLoading() {
    this.loading = await this.loadingCtrl.create({
      message: '<img src="assets/imgs/preloader.gif" alt="loading...">',
      cssClass: 'custom_loading',

      // showBackdrop: false,
      // spinner: 'hide',
    });
    await this.loading.present();
  }
  demo() {
    console.log('demo works');
  }
  async openMenu(business) {
    let type = 'now';
    if (type == 'now') {
      this.globals.order_time = 'now';
      this.globals.myDate = undefined;
      localStorage.setItem('scheduled_time', undefined);
    }

    console.log('menu......', business);
    let modal = await this.modalCtrl.create({
      component: MenuPage,
      componentProps: {
        businessData: business,
        business_id: business.business_id,
      },
      cssClass: 'menuModal',
    });

    modal.present();
  }
  // alertS(){
  // this.globals.presentToast('hello from keyboard')
  // }
  cuisineData(data, id, index) {
    this.showLoading = true;
    this.pageLoading();
    this.globals.activeCuisineList = 'cuisines';
    this.globals.activeCuisine = data;
    this.globals.activeCuisineName = data.title;
    this.globals.cuisineID = id;
    this.showProfileCard = false;
    this.showNotif = false;
    this.router.navigate(['/search-business']);

    // this.activeColor="#007ce7"
    // this.globals.cuicineID = id;
    // console.log(data, index)

    //      var btnContainer = document.getElementById("cuisine_container");

    // // Get all buttons with class="btn" inside the container
    // var btns = btnContainer.getElementsByClassName("cuisine_item");

    // // Loop through the buttons and add the active class to the current/clicked button
    // for (var i = 0; i < btns.length; i++) {
    //   btns[i].addEventListener("click", function() {
    //     var current = document.getElementsByClassName("active");

    //     // If there's no active class
    //     if (current.length > 0) {
    //       current[0].className = current[0].className.replace(" active", "");
    //     }

    //     // Add the active class to the current/clicked button
    //     this.className += " active";
    //   });
    // }
  }
  async askForPhone() {
    const modal = await this.modalCtrl.create({
      component: AskPhonePage,
      componentProps: {},
      cssClass: 'phoneModal',
    });
    modal.present();
    modal.onDidDismiss().then((res) => {
      this.getLoginInfo();
    });
  }
  async referFriend() {
    let currentUrl = window.location.hostname;
    // console.log(currentUrl)
    //change Weburl if changing domain.
    if (this.globals.webURL == currentUrl) {
      const alert = await this.alertCtrl.create({
        message: 'Coming soon.',
        buttons: ['Okay'],
        cssClass: 'customAlert',
      });
      await alert.present();
    } else {
      let Title = 'The Halal Guide';
      let msg =
        Title +
        ' is one of the best halal food ordering apps. Order now';
      // this.socialShare.canShareVia
      // net.thehalalguide.app://thehalalguide.com
      let B_link = 'http://halalguide.app.link/jYA2rkA33kb';

      // let simpleAppURL='http://halalguide.app.link/jYA2rkA33kb';
      // if(this.platform.is('browser') || this.platform.is('mobileweb')){

      // }
      this.socialShare
        .share(msg, Title, null, B_link)
        .then((res) => {
          console.log('share via referFriend', res);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //  if(this.platform.is('android') || this.platform.is('ios')){

    //   else{

    //   }
  }
  async perks() {
    const alert = await this.alertCtrl.create({
      message: 'Coming soon.',
      buttons: ['Ok'],
    });
    await alert.present();
  }
  openAddressesPage() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('addresses');
  }
  openPaymentsPage() {
    this.showProfileCard = false;
    this.showNotif = false;
    // if (this.globals.Product.length == 0) {
    //   let alert = this.alertCtrl.create({
    //     title: "Payments",
    //     message: "Since your cart is empty. you cannot access payments page",
    //     buttons: ["Okay"],
    //   });
    //   alert.present();
    // } else {
    //   this.showProfileCard = false;
    //   this.showNotif = false;
    //   this.navCtrl
    //     .push("CartPage", {})
    //     .then(
    //       (response) => {
    //         console.log("Response " + response);
    //       },
    //       (error) => {
    //         console.log("Error: " + error);
    //       }
    //     )
    //     .catch((exception) => {
    //       console.log("Exception " + exception);
    //     });
    // }
    // let modal = this.modalCtrl.create("PaymentMethodsPage");
    // modal.present();
    this.navCtrl.navigateForward('payment-methods');
    // console.log('')
  }
  openFavPage() {
    this.globals.activeCuisineList = 'favorites';
    this.showProfileCard = false;
    this.showNotif = false;
    this.router.navigate(['/search-business']);
  }
  // show and hide header cards
  showProfile() {
    this.showNotif = false;
    if (this.showProfileCard == true) {
      this.showProfileCard = false;
    } else {
      this.showProfileCard = true;
    }
  }
  showNotifications() {
    this.showProfileCard = false;

    if (this.showNotif == true) {
      this.showNotif = false;
    } else {
      this.showNotif = true;
    }
    this.newArray = [];
    if (this.showNotif == true) {
      this.getAllNotifications();
      this.getNotificationTime();
    }
  }
  // show and hide header cards ends.
  openProfile() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('settings');
  }
  // async logout() {
  //   const alert = this.alertCtrl.create({
  //     title: "Logout",
  //     message: "You are about to logout. This will clear your cart and saved information.",
  //     buttons: [
  //       {
  //         text: "Stay Logged in",
  //         cssClass: 'cancel_btn',
  //         handler: (data) => {
  //           this.showProfileCard = false;
  //           this.showNotif = false;
  //           console.log("Cancel clicked");
  //         },
  //       },
  //       {
  //         text: "Logout",
  //         handler: (data) => {
  //           this.showProfileCard = false;
  //           this.globals.Product.length = 0;
  //           this.globals.cartflag = false;
  //           this.globals.guess_login = true;
  //           localStorage.removeItem("isLogin");
  //           localStorage.removeItem("firstname");
  //           localStorage.removeItem("addresses");
  //           localStorage.removeItem("myFavorites");
  //           localStorage.removeItem("udid");
  //           localStorage.setItem('isSocialLogin', JSON.stringify(false));
  //           this.nativeStorage
  //             .remove("user")
  //             .then((data) => { })
  //             .catch((err) => console.log());

  //           //logout from google
  //           this.googlePlus.logout().then(res => {
  //             console.log('google login cleared', res);
  //           });
  //           //logout from fb
  //           this.facebook.getLoginStatus().then(res => {
  //             console.log('facebook login status response', res)
  //             if (res.status === 'connected') {
  //               this.facebook.logout().then(res => {
  //                 console.log('logout from facebook', res);
  //               }).catch(err => {
  //                 console.log('fb failed logout', err);
  //               });
  //             }
  //           })

  //           // this.facebook.getLoginStatus().then(res=>{ //check if login
  //           // if(res.status=='connected'){
  //           //   this.facebook.logout().then(res=>{
  //           //     console.log('logout from facebook',res)
  //           // }).catch(err=>{
  //           //     console.log('fb failed logout',err)
  //           // })
  //           //  this.app.getRootNav().setRoot("LandingPage");
  //           // }
  //           // })
  //           this.app.getRootNav().setRoot("LandingPage");
  //         },
  //       },
  //     ],
  //   });
  //   await alert.present();
  //   // this.nativeStorage.remove('user').then(data => {

  //   // }).catch(err => console.log());
  // }
  followUs(){
this.showProfileCard = false;
    this.navCtrl.navigateForward('follow-us');
  }
  goToGifts() {
    this.showProfileCard = false;
    this.navCtrl.navigateForward('gift-cards');
  }

  saveAddress() {
    // this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    this.hasData = true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
  }
  editAddress() {
    this.addressSearch = true;
  }
  dismiss() {
    this.temp = false;
    this.autocompleteItems = [];
  }
  // loadBanner() {
  //   let response = this.server.LoadBannersOnHomePage();
  //   response.subscribe((data) => {
  //     console.log(data);
  //   });
  // }

  cancelAddressSearch() {
    this.addressSearch = false;
  }
  chooseItem(item: any) {
    if (item == undefined || item == null) {
      this.globals.presentToast('Invalid address!');
      return;
    }
    this.autocomplete.query = item;
    this.geo = item;
    this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    // this.hasData=true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
    this.dismiss();
    this.geoCode(this.geo);
    console.log('item', item);
    console.log('geo', this.geo);
  }
  geoCode(address: any) {
    // let that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        ',' +
        results[0].geometry.location.lng();
      // new added
      this.globals.dataNotLoaded = true;
      this.offset = 0;
      this.limit = 20;
      this.resList = [];
      this.items = [];
      this.list();
      // new added
    });
  }
  updateSearch() {
    console.log('search is on');
    console.log(this.autocompleteItems);
    console.log('length', this.autocomplete.query.length);

    if (this.autocomplete.query == '') {
      console.log('if run');
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log('else if run');
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          componentRestrictions: {
            country: ["us", "ca"],
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log('else run');
    }
  }

  floated(x) {
    return Number.parseFloat(x).toFixed(1);
  }

  login() {
    this.navCtrl.navigateForward('/login');
  }

  register() {
    this.navCtrl.navigateForward('signup');
  }
  goToBusinessList() {
    this.showLoading = true;
    // this.pageLoading();
    this.showProfileCard = false;
    this.globals.activeCuisineList = 'all';
    this.showNotif = false;
    this.router.navigate(['/search-business']);
  }
  async cartpage() {
    this.showProfileCard = false;
    this.showNotif = false;
    if (this.globals.Product.length == 0) {
      let alert = await this.alertCtrl.create({
        header: 'Empty cart',
        message: 'Hungry? order some food now',
        buttons: ['Okay'],
      });
      alert.present();
    } else {
      this.showProfileCard = false;
      this.showNotif = false;
      this.navCtrl
        .navigateForward('cart', {})
        .then(
          (response) => {
            console.log('Response ' + response);
          },
          (error) => {
            console.log('Error: ' + error);
          }
        )
        .catch((exception) => {
          console.log('Exception ' + exception);
        });
    }
  }
  openbusinessDetail(business) {
    // this.showLoading = true;
    // const loading= this.loadingCtrl.create({
    //   content:'Please wait...'
    // })
    // await loading.present();
    // this.pageLoading();
    this.showProfileCard = false;
    this.showNotif = false;
    this.globals.bussinessId = business.business_id;
    console.log('showing this businness=> ', business);
    let name = business.name + '-' + business.address;
    console.log(business.name, business.address);
    name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');
    // value=value.replace(/,/g,'')
    this.router.navigateByUrl('' + name + '/' + business.business_id, {
      state: { businessData: business, uniqueid: business.business_id },
    });
    //pending hai
    // this.navCtrl.navigateForward("CategoryPage", {state:{ businessData: business ,uniqueid:business.business_id}});
    // console.log('send to cat page')
    // loading.dismiss();
  }
  openHistory() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('my-orders');
  }

  // list() {
  //   let response = this.server.getRestaurantslist(
  //     "100000",
  //     "main",
  //     this.globals.mycoordinates,
  //     "0",
  //     "order",
  //     5
  //   );
  //   response.subscribe(
  //     (data) => {
  //       this.resList = data.results;
  //       // console.log(this.items);
  //       // this.limit=this.limit+5;
  //       // this.resList=this.items

  //     },
  //     (error) => {
  //       this.globals.presentToast(
  //         "Something went wrong check your internet connection."
  //       );
  //     }
  //   );
  // }

  async addNewRes() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('add-new-business', {});
    // let profileModal = this.modalCtrl.create(AddNewBusinessPage, { data: {} });
    // profileModal.present();
  }

  async changeRadius() {
    let alert = await this.alertCtrl.create({
      header: 'Select Radius',
      mode: 'ios',
      inputs: [
        {
          name: '1',
          type: 'radio',
          label: '1 Mile',
          value: '1',
          handler: (e) => {
            console.log(e);
          },
        },
        {
          name: '5',
          type: 'radio',
          label: '5 Miles',
          value: '5',
          handler: (e) => {
            console.log(e);
          },
        },
        {
          name: '10',
          type: 'radio',
          label: '10 Miles',
          value: '10',
          handler: (e) => {
            console.log(e);
          },
          // checked: true,
        },
        {
          name: '25',
          type: 'radio',
          label: '25 Miles',
          value: '25',
          handler: (e) => {
            console.log(e);
          },
        },
        {
          name: '50',
          type: 'radio',
          label: '50 Miles',
          value: '50',
          handler: (e) => {
            console.log(e);
          },
        },
        // {
        //   name: '50',
        //   type: 'radio',
        //   label: 'All',
        //   value: '100000',
        //   handler: (e) => {
        //     console.log(e);
        //   },
        // },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Change',
          handler: (data) => {
            this.globals.radius = Number(data);
            this.globals.dataNotLoaded = true;
            this.resList = [];
            this.hasData = true;
            this.offset = 0;
            this.limit = 20;
            this.list();

            console.log(data);
          },
        },
      ],
    });
    alert.present();
  }
  async leaderboard() {
    this.showProfileCard = false;
    this.showNotif = false;
    let modal = await this.modalCtrl.create({
      component: ReviewsLeaderboardPage,
      cssClass:'review_leaderBoard',
    });
    await modal.present();
    // this.navCtrl.push('ReviewsLeaderboardPage');
  }
  helpPage() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('about-us');
  }
  blogsPage() {
    this.showProfileCard = false;
    this.showNotif = false;
    this.navCtrl.navigateForward('blogs');
  }
  async surveyAlert() {
    const modal = await this.modalCtrl.create({
    component: SurveyAlertPage,
    componentProps: { value: 123 },
    cssClass:'surveyAlert',

    });
  
    await modal.present();
  
    const data = await modal.onDidDismiss();
    console.log(data)
    if(data.data){
      if(this.globals.EventList.length==1){
      let name
       let event= this.globals.EventList[0];
       name=event.event_name
       name = name.replace(/[^a-zA-Z ]/g, '');
       name = name.replace(/ /g, '-');
       name = name.replace(/--/g, '-');
  this.router.navigateByUrl('event/'+name+'/'+event.event_id,{state:{event:event}})


      }
      else{
    this.router.navigateByUrl('events')

      }
    }
  
  }
}
